import ProjectSession from "../../../../../core/model2/project/project-session"
import {SpaceProto} from "../../../../../core/model2/space/space-proto"
import NavigationMenu_ProjectsLocalSettings from "../../../local-settings"
import {menu_sortProjects} from "../../../menu-items/project/functions/order-projects"

// An expanded row's children render directly below its own row (menu-item-project-with-reorder.tsx),
// so the row visually above a given row is not always that row's own previous sibling - it can be that
// sibling's last expanded descendant instead. Walks the same expansion/sort/filter rules the tree
// renders with (see ProjectsReorderList) to find it.
export default function menuProjects_lastVisibleDescendant(project: ProjectSession, localSettings: NavigationMenu_ProjectsLocalSettings, space: SpaceProto): ProjectSession {
    const isExpanded = localSettings.expandedProjects.includes(project.id) && project.hasAccessibleChildren

    if (!isExpanded) {
        return project
    }

    const children = _.filter(menu_sortProjects(project.treeChildren, space), (child: ProjectSession) => {
        return !child.isArchived && (!!child.access || !!child.treeChildren)
    })

    const lastChild = _.last(children)

    if (!lastChild) {
        return project
    }

    return menuProjects_lastVisibleDescendant(lastChild, localSettings, space)
}
